import React from 'react';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons/faPlusCircle';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons/faMinusCircle';

import Button, { BUTTON_SIZES, BUTTON_TYPES } from 'buyside/components/presentation/Button/button';

const AddRemoveButton = ({ type, text, onClick, disabled }) => {
  const isRemove = type === 'remove';
  const icon = isRemove ? faMinusCircle : faPlusCircle;
  return (
    <Button
      text={text}
      onClick={onClick}
      disabled={disabled}
      type={isRemove ? BUTTON_TYPES.DANGER : BUTTON_TYPES.PRIMARY}
      faIcon={icon}
      size={BUTTON_SIZES.TINY}
      buttonType={BUTTON_TYPES.BUTTON}
    />
  );
};

export default AddRemoveButton;
